var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BbCropper',{attrs:{"parent":_vm.context,"ident":_vm.config.ident,"CustomImageConfig":_vm.customImageConfig,"key-string":_vm.config.prop}})
}
var staticRenderFns = []

export { render, staticRenderFns }